import { render } from "./SidebarComp.vue?vue&type=template&id=7092f480&scoped=true&ts=true"
import script from "./SidebarComp.vue?vue&type=script&lang=ts"
export * from "./SidebarComp.vue?vue&type=script&lang=ts"

import "./SidebarComp.vue?vue&type=style&index=0&id=7092f480&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Documents\\Code\\VSProjects\\modboxProject\\modbox\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7092f480"]])

export default __exports__